import React from "react";
import { useTranslation } from "react-i18next";
import { deleteSheet } from "../actions";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { Targets, Actions } from "constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";

const DeleteSheet = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName } = sheet;
  // Auth checks done in SheetActions.js

  return (
    <ModalBuilder
      withForm
      submitAction={deleteSheet}
      submitParams={{ sheetId }}
      onSubmitted={onSubmitted}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.DeleteSheet.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal
          {...modalProps}
          header={t("SheetActions.DeleteSheet.HeaderText")}
          size="small"
        >
          {t("SheetActions.DeleteSheet.ConfirmMessage", { sheetName })}
        </TranslatedModal>
      )}
    />
  );
};

export default withRouter(DeleteSheet);
